<template>
  <div class="flex flex-col w-full h-full min-h-0">
    <files-view-and-upload v-model="files" :customer="customer" @refresh="fetchFiles" />
  </div>
</template>

<script setup lang="ts">

import { PropType, ref, watch } from 'vue';
import { ICustomer, ICustomerFile } from '@torim-app/types';
import { CustomersApi } from '@app/api/admin';

const props = defineProps({
  customer: {
    type: Object as PropType<ICustomer>,
    required: true
  }
});

// Seed from whatever the parent already has for an instant render, then always
// refresh from the server so the tab is up to date (this component is mounted via
// v-if each time the Files tab is opened).
const files = ref<ICustomerFile[]>(props.customer?.files ? [...props.customer.files] : []);

const fetchFiles = async () => {
  const customerId = props.customer?.id;
  if (!customerId) return;
  try {
    const fresh = await CustomersApi.fetchCustomer(customerId);
    files.value = fresh.files ? [...fresh.files] : [];
  } catch (e) {
    console.error('Failed to refresh customer files:', e);
  }
};

// Fetch on setup and whenever the customer id becomes available (async load).
watch(() => props.customer?.id, () => fetchFiles(), { immediate: true });
</script>

<style scoped lang="scss">

</style>
